// extracted by mini-css-extract-plugin
export default {"container":"Invoices_container__FbeXb","centered":"Invoices_centered__884pS","pagination":"Invoices_pagination__pdA52"};